<template>
    <v-dialog
    v-model="shown"
    max-width="900"
    :fullscreen="isMobile"
  >
    <v-card>
      <v-card-title class="headline">
        <v-row>
          <v-col cols="11" v-html="title">
          </v-col>
          <v-col cols="1" class="px-0" v-if="isMobile">
            <ButtonActionClose @click="shown = false" />
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text v-show="articleLoaded">
        <ArticleCardForm
          ref="articleCardForm"
          @submit="search"
          @print="print"
        />
      </v-card-text>

      <v-card-text v-if="loading">
        <AppSpinner />
      </v-card-text>
      <v-card-text v-if="articleLoaded && !loading && articleCardData">
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  <div>Dokument</div>
                  <div>Datum</div>
                </th>
                <th colspan="2">
                  <div class="text-center">Količina</div>
                  <div>poraba <span class="float-right pr-2">prejem</span></div>
                </th>
                <th colspan="2">
                  <div class="text-center">Nabavna cena</div>
                  <div>poraba <span class="float-right pr-2">prejem</span></div>
                </th>
                <th colspan="2">
                  <div class="text-center">Nabavna vrednost</div>
                  <div>poraba <span class="float-right pr-2">prejem</span></div>
                </th>
                <th colspan="2">
                  <div class="text-center" style="min-height: 22px;"></div>
                  <div> <span class="float-right pr-2">Zaloga na dan</span></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(doc, i) of articleCardData.documents"
                :key="i"
              >
                <td>
                  <!-- {{!doc.is_reset ? doc.document : doc.document+' - ZS'}} -->
                  {{doc.document}}
                  <br>
                  {{doc.date | sloDate}}
                </td>
                <td>{{doc.spent_quantity | price}}</td>
                <td>{{doc.received_quantity | price}}</td>
                <td>{{doc.spent_price | price(2)}}</td>
                <td>{{doc.received_price | price(2)}}</td>
                <td>{{doc.spent_amount | price(2)}}</td>
                <td>{{doc.received_amount | price(2)}}</td>
                <td class="text-right">{{doc.cumulative | price(2)}}</td>
              </tr>
              <tr>
                <td></td>
                <td class="font-weight-bold" >{{articleCardData.total_spent_quantity | price}}</td>
                <td class="font-weight-bold" >{{articleCardData.total_received_quantity | price}}</td>
                <td></td>
                <td></td>
                <td class="font-weight-bold" >{{articleCardData.total_spent_amount | price(2)}}</td>
                <td class="font-weight-bold" >{{articleCardData.total_received_amount | price(2)}}</td>
              </tr>
              <tr>
                <td colspan="3" class="font-weight-bold text-right" >Razlika obdobja: {{articleCardData.period_cumulative.toString().replace('.', ',')}}</td>
                <td></td>
                <td colspan="3" class="font-weight-bold text-right" >Razlika obdobja: {{articleCardData.period_stock | price(2)}}</td>
              </tr>
              <tr>
                <td colspan="3" class="font-weight-bold text-right" >Zaloga na dan {{currentFilters.endDate | sloDate}}: {{articleCardData.end_cumulative.toString().replace('.', ',')}}</td>
                <td></td>
                <td colspan="3" class="font-weight-bold text-right" >Vrednost na dan {{currentFilters.endDate | sloDate}}: {{articleCardData.end_stock | price(2)}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import ArticleCardForm from './ArticleCardForm'
import ButtonActionClose from './ButtonActionClose'
export default {
  components: {
    ArticleCardForm,
    ButtonActionClose
  },
  props: {
    articleId: {
      type: Number
    }
  },
  data () {
    return {
      shown: false,
      loading: false,
      articleLoaded: false,
      articleCardData: null,
      currentFilters: null
    }
  },
  computed: {
    article () {
      return this.$store.state.articles.items[this.articleId]
    },
    title () {
      if (!this.articleLoaded) return ''
      if (!this.article) return ''
      if (this.isMobile) return `Kartica artikla<br>${this.article.name}`
      return `Kartica artikla - ${this.article.name}`
    },
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    }
  },
  methods: {
    ...mapActions('articles', { loadArticle: 'loadItem' }),
    ...mapActions('articleCard', { loadArticleCard: 'loadItem' }),
    close () {
      this.shown = false
    },
    open () {
      this.shown = true
      this.loading = false
      this.articleLoaded = false
      this.articleCardData = null
      if (this.$refs.articleCardForm) {
        this.$refs.articleCardForm.clearForm()
      }
      this.$nextTick(() => {
        this.init()
      })
    },
    search (filters) {
      this.currentFilters = filters
      this.loading = true
      this.loadArticleCard({
        article: this.articleId,
        filters: {
          dateFrom: filters.startDate,
          dateTo: filters.endDate
        }
      })
        .then(response => {
          this.articleCardData = response
        })
        .finally(() => {
          this.loading = false
        })
    },
    print (form) {
      const filters = {
        article: this.articleId,
        dateFrom: form.startDate,
        dateTo: form.endDate
      }

      let routeData = this.$router.resolve({ name: 'MyCompanyArticleCardPreview', query: filters })
      window.open(routeData.href, '_blank')
    },
    async init () {
      try {
        this.loading = true
        if (!this.article) {
          await this.loadArticle(this.articleId)
        }
        this.articleLoaded = true
        this.$refs.articleCardForm.submit()
      } catch (e) {

      }
    }
  }
}
</script>
